module.exports = {"620823001":"城市社区管理委员会街道","620823100":"锦屏镇","620823101":"新窑镇","620823102":"柏树镇","620823103":"黄寨镇","620823202":"黄花乡","620823203":"木林乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620823.json
// module id = 3066
// module chunks = 0